import React from 'react'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { preprocessText } from '@aytm/lib/common/func'

export default class InvoiceTableRow extends PureDataComponent {
  constructor(...args) {
    super(...args);
    this.renderLeveledText = this.renderLeveledText.bind(this);
    this.preprocessText = this.preprocessText.bind(this);
  }

  renderLeveledText(text, level = 0, className) {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: this.preprocessText(text) }}
        style={{ paddingLeft: level > 0 ? level * 20 : null }}
        className={className}
      />
    )
  }

  preprocessText(text = '') {
    return preprocessText(text)
  }
}
